import { httpGet } from '../../utils/httpClient';
import { PopularDirections } from '../../components/LandingPage/PopularDirections/PopularDirections';
import { withLayout } from '../../Layout/Layout';
import ScrollableContent from '../../components/ScrollableContent/ScrollableContent';
import styles from '../../components/LandingPage/LandingPage.module.scss';
import React from 'react';
import cn from 'classnames';

export const getServerSideProps = async ({
  query: { routesPage = 0, directionsPage = 0 },
}) => {
  const popularDirectionsRes = await httpGet(
    `${process.env.javaApiUrl}/landing/list?textIdClass=first-class&directionsOnly=true&page=${directionsPage}&size=18`
  );
  const popularRoutesRes = await httpGet(
    `${process.env.javaApiUrl}/landing/list?textIdClass=first-class&routesOnly=true&page=${routesPage}&size=18`
  );

  const recommendationRes = await httpGet(
    `${process.env.javaApiUrl}/recommendation`
  );
  const recommendation = await recommendationRes.json();
  if (popularDirectionsRes.status >= 400) {
    return {
      notFound: true,
    };
  }
  const popularDirections = await popularDirectionsRes.json();
  const popularRoutes = await popularRoutesRes.json();
  const totalRoutesPages = popularRoutes.totalPages;
  const totalDirectionsPages = popularDirections.totalPages;

  return {
    props: {
      popularDirections,
      popularRoutes,
      recommendation,
      totalRoutesPages,
      totalDirectionsPages,
      routesPage,
      directionsPage,
    },
  };
};

function Flights({
  popularDirections,
  popularRoutes,
  recommendation,
  routesPage,
  directionsPage,
  totalRoutesPages,
  totalDirectionsPages,
  authCompleted,
}) {
  const seoHtml = (
    <div className={cn('container', styles.seoContent, 'mt-4', 'lg:pl-4', 'px-4', 'lg:pr-0')}>
      <h2>Find Cheap First Class Flights & Tickets </h2>
      <p>
        Looking for first class flights without paying more than you need to? <a href="/">First-Class.com</a> makes it easy to search and compare first class tickets from airlines and travel providers around the world.
      </p>
      <p>
        Whether you&apos;re planning a long-haul journey, a special holiday, an important business trip, or simply want to make your next flight more comfortable, our flight search helps you find available first class airfare for your preferred route and dates.
      </p>
      <p>
        Compare flights, airlines, schedules and prices in one place, then choose the first class ticket that works best for your trip.
      </p>
      <h2>
        Find Cheap First Class Flights
      </h2>
      <p>
        Flying first class is often associated with eye-watering prices, but the fare you pay can vary considerably depending on the airline, route, aircraft, travel dates and availability.
      </p>
      <p>
        That&apos;s why comparing different options can make a big difference.
      </p>
      <p>
        <a href="/">First-Class.com</a> helps you search for cheap first class flights, compare available fares and find opportunities to travel in a premium cabin for less. You can search one-way and return itineraries and compare different airlines and flight options before making your booking.
      </p>
      <p>
        If your dates are flexible, you may also be able to find better first class fares by checking alternative
        departure dates or nearby airports.
      </p>
      <h3>
        Why compare first class tickets?
      </h3>
      <p>
        A first class ticket can represent a significant investment, so it pays to look beyond the first price you see. When comparing flights, consider:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li>The total ticket price </li>
        <li>The airline and aircraft </li>
        <li>Flight duration </li>
        <li>Number of connections </li>
        <li>Departure and arrival times </li>
        <li>Seat or suite configuration </li>
        <li>Baggage allowance </li>
        <li>Lounge access </li>
        <li>Dining and onboard service </li>
        <li>Fare conditions and flexibility </li>
      </ul>
      <p>
        The cheapest first class ticket isn&apos;t necessarily the right choice for every traveller. Comparing the complete experience alongside the price can help you find better value.
      </p>
      <h2>First Class Airfare From Leading Airlines </h2>
      <p>
        First class is not the same across every airline. Some carriers operate highly private suites with closing doors, while others offer spacious reclining seats or lie-flat beds.
      </p>
      <p>
        <a href="/">First-Class.com</a> lets you compare first class flights from airlines serving destinations around the world.
      </p>
      <p>
        Some airlines known for offering first class on selected routes include:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li>Emirates</li>
        <li>Singapore Airlines</li>
        <li>Etihad Airways</li>
        <li>Lufthansa</li>
        <li>British Airways</li>
        <li>Air France</li>
        <li>Cathay Pacific</li>
        <li>ANA</li>
        <li>Qatar Airways</li>
        <li>Japan Airlines</li>
      </ul>
      First class availability depends on the airline, aircraft and route. An airline may offer first class on one long-haul service but operate business class as its highest cabin on another.
      For that reason, check the specific flight and aircraft when comparing first class tickets.
      <h2>What Is First Class Like?</h2>
      <p>
        First class is the most exclusive cabin offered by many commercial airlines. While the experience varies significantly between carriers, first class generally focuses on greater space, privacy, personalised service and premium amenities.
      </p>
      <p>
        On some international flights, passengers may have their own private suite, while other first class cabins use spacious seats with generous legroom and recline.
      </p>
      <p>
        Depending on the airline and aircraft, your first class experience could include:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li>A spacious seat or private suite</li>
        <li>A fully flat bed on selected long-haul flights</li>
        <li>Premium bedding and amenity kits</li>
        <li>Gourmet meals and premium beverages</li>
        <li>Dedicated cabin crew</li>
        <li>Priority check-in and boarding</li>
        <li>First class lounge access</li>
        <li>Increased baggage allowance</li>
        <li>Premium airport services</li>
        <li>High-quality entertainment systems</li>
      </ul>
      <p>
        The exact benefits depend on the airline, aircraft, route and fare purchased.
      </p>
      <h2>First Class Suites and Seats</h2>
      <p>
        One of the biggest differences between first class products is the seat itself.
      </p>
      <p>
        On some of the world&apos;s most premium aircraft, first class passengers can travel in a private suite with doors, personal storage and a dedicated sleeping area.
      </p>
      <p>
        Other aircraft feature large, comfortable seats that recline into beds. On shorter routes, first class may instead consist of a wider reclining seat with additional space and enhanced service.
      </p>
      <p>
        If the seat is an important part of your decision, don&apos;t compare airlines based solely on the cabin name. Check the aircraft operating your particular flight, as an airline can offer several different first class products.
      </p>
      <h2>First Class Dining</h2>
      <p>
        Food and drinks are another important part of the first class experience.
      </p>
      <p>
        Depending on the airline, passengers may receive restaurant-style meals, extensive menus, premium wines and champagne, and a selection of snacks and refreshments throughout the flight.
      </p>
      <p>
        Some airlines allow first class passengers to choose when they would like to dine, while others offer scheduled meal services.
      </p>
      <p>
        Menus and beverages vary by route and aircraft, so check the details of your specific flight before booking if dining is a major consideration.
      </p>
      <h2>First Class Lounge Access</h2>
      <p>
        For many travellers, the first class experience starts before boarding.
      </p>
      <p>
        Eligible first class passengers may have access to dedicated first class lounges or premium areas within an airline&apos;s lounge network. Depending on the airport, facilities can include:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li>À la carte restaurants</li>
        <li>Bars</li>
        <li>Showers</li>
        <li>Private rooms</li>
        <li>Sleeping areas</li>
        <li>Workspaces</li>
        <li>Relaxation areas</li>
        <li>Dedicated boarding facilities</li>
      </ul>
      <p>
        Lounge access isn&apos;t identical across airlines, and some airports may not have a dedicated first class lounge. Always check what is available at your departure and connecting airports.
      </p>
      <h2>First Class vs Business Class</h2>
      <p>
        Business class has improved significantly in recent years, with many airlines now offering lie-flat seats, direct aisle access and premium lounges.
      </p>
      <p>
        So what&apos;s the difference between business class and first class?
      </p>
      <p>
        It depends on the airline and aircraft.
      </p>
      <p>
        First class typically offers a higher level of privacy and exclusivity, while business class is more widely available and can offer many of the same practical benefits.
      </p>
      <p>
        For a long overnight flight, the additional privacy and space of first class can be particularly appealing. For other journeys, business class may provide many of the features you want at a lower price.
      </p>
      <h2>First Class vs Economy</h2>
      <p>
        The difference between first class and economy is generally much more substantial.
      </p>
      <p>
        Economy is designed to provide efficient and affordable transportation, while first class places considerably more emphasis on comfort, space and personalised service.
      </p>
      <p>
        A first class ticket may provide:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li>More legroom and personal space</li>
        <li>Wider seating</li>
        <li>Greater recline</li>
        <li>A lie-flat bed on selected flights</li>
        <li>More privacy</li>
        <li>Premium dining</li>
        <li>Priority airport services</li>
        <li>Lounge access</li>
        <li>Additional baggage</li>
        <li>Enhanced onboard amenities</li>
      </ul>
      <p>
        For long-haul flights, the ability to sleep in a fully flat bed can be one of the biggest advantages of upgrading to first class.
      </p>
      <h2>How to Find Cheap First Class Tickets</h2>
      <p>
        There isn&apos;t one trick that guarantees cheap first class airfare, but a few strategies can improve your chances of finding a lower fare.
      </p>
      <h3>Be flexible with your dates</h3>
      <p>
        First class fares can change significantly from one day to another. If you have flexibility, search several departure dates rather than looking at only one.
      </p>
      <h3>Compare different airlines</h3>
      <p>
        Don&apos;t limit your search to the airline you normally fly. Different carriers can have very different first class fares on the same route.
      </p>
      <h3>Consider nearby airports</h3>
      <p>
        If your destination has several airports, check them all. The difference between airports can sometimes open up additional flight options.
      </p>
      <h3>Compare connecting flights</h3>
      <p>
        A nonstop flight is usually the most convenient option, but connecting flights can sometimes offer different first class fares and availability.
      </p>
      <h3>Book around peak travel periods carefully</h3>
      <p>
        Christmas, New Year, major holidays and school vacation periods can create additional demand for premium cabins. Searching early can give you more choice.
      </p>
      <h3>Compare the entire itinerary</h3>
      <p>
        A low first class fare isn&apos;t necessarily a good deal if it involves a significantly longer journey or inconvenient connections.
      </p>
      <p>
        Look at the total travel time, aircraft, seat, connections, baggage allowance and fare conditions alongside the price.
      </p>
      <h2>How Much Do First Class Tickets Cost?</h2>
      <p>
        There is no standard price for a first class ticket.
      </p>
      <p>
        A short domestic first class flight can cost only moderately more than economy, while an international long-haul first class ticket can cost several thousand dollars or more.
      </p>
      <p>
        Prices depend on factors including:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li>Airline</li>
        <li>Route</li>
        <li>Aircraft</li>
        <li>Travel dates</li>
        <li>Season</li>
        <li>Demand</li>
        <li>Seat availability</li>
        <li>Number of passengers</li>
        <li>One-way or return travel</li>
        <li>Fare conditions</li>
      </ul>
      <p>
        The same route can also have substantially different first class fares depending on the date and airline.
      </p>
      <p>
        That&apos;s why searching and comparing current fares is more useful than relying on an average first class ticket price.
      </p>
      <h2>Popular First Class Flight Destinations</h2>
      <p>
        First class is particularly common on long-haul routes connecting major international hubs.
      </p>
      <p>
        Popular destinations for first class travellers include:
      </p>
      <h3>First Class Flights to Europe</h3>
      <p>
        Search first class flights to cities including:
      </p>
        <ul className="list-disc ml-8 mb-2">
        <li>London</li>
        <li>Paris</li>
        <li>Frankfurt</li>
        <li>Munich</li>
        <li>Amsterdam</li>
        <li>Madrid</li>
        <li>Barcelona</li>
        <li>Rome</li>
        <li>Milan</li>
        <li>Zurich</li>
        <li>Vienna</li>
      </ul>
      <p>
        Europe is served by a mixture of European, Middle Eastern, Asian and North American airlines offering first class on selected routes.
      </p>
      <h3>First Class Flights to the United States</h3>
      <p>
        Popular first class destinations in the US include:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li>New York</li>
        <li>Los Angeles</li>
        <li>San Francisco</li>
        <li>Miami</li>
        <li>Chicago</li>
        <li>Boston</li>
        <li>Washington, D.C.</li>
        <li>Houston</li>
        <li>Dallas</li>
        <li>Seattle</li>
      </ul>
      <p>
        It&apos;s important to distinguish between domestic and international first class in the United States. Domestic first class typically offers a larger reclining seat and enhanced service, while international first class can include private suites and fully flat beds.
      </p>
      <h3>First Class Flights to Asia</h3>
      <p>
        Asia has some of the world&apos;s most distinctive premium airline products.
      </p>
      <p>
        Popular destinations include:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li>Tokyo</li>
        <li>Singapore</li>
        <li>Hong Kong</li>
        <li>Bangkok</li>
        <li>Seoul</li>
        <li>Shanghai</li>
        <li>Beijing</li>
        <li>Kuala Lumpur</li>
        <li>Sydney</li>
      </ul>
      <p>
        First class availability varies considerably by route and aircraft, so check the specific flight when searching.
      </p>
      <h3>First Class Flights to the Middle East</h3>
      <p>
        The Middle East is a major hub for premium international travel.
      </p>
      <p>
        Popular destinations include:
      </p>
      <ul className="list-disc ml-8 mb-2">
        <li>Dubai</li>
        <li>Abu Dhabi</li>
        <li>Doha</li>
        <li>Riyadh</li>
        <li>Jeddah</li>
      </ul>
      <p>
        Airlines based in the region connect these cities with major destinations across Europe, Asia, Africa, Australia and North America.
      </p>
      <h2>Find Your First Class Flight </h2>
      <p>
        Whether you&apos;re searching for cheap first class flights, comparing first class tickets, or looking for a premium long-haul experience, <a href="/">First-Class.com</a> makes it easier to explore your options.
      </p>
      <p>
        Search your route, compare available fares and find the first class flight that fits your journey.
      </p>
      <p>
        Start searching for first class flights with <a href="/">First-Class.com</a>.
      </p>
      <h2>Frequently Asked Questions About First Class Flights</h2>

      <p>
        Finding and booking a first class flight doesn&apos;t have to be complicated.
      </p>
      <p>
        Start by entering your departure airport, destination and travel dates into the <a href="/">First-Class.com</a> flight search.
      </p>
      <p>
        Select First Class as your preferred cabin and compare the available options.
      </p>
      <p>
        Pay attention to the airline, aircraft, number of stops, journey time and fare conditions as well as the ticket price.
      </p>
      <p>
        Once you&apos;ve found a flight that suits your requirements, follow the booking process provided for that fare.
      </p>



      {+directionsPage === 0 && +routesPage === 0 && (
        <div className={'mt-4'}>
          <ScrollableContent
            heading={
              <h3>
                When Is the Best Time to Book First Class Flights?
              </h3>
            }
            content={
              <div>
                <p>
                  There isn&apos;t a universal day or number of days before departure that guarantees the lowest first class fare.
                </p>
                <p>
                  Prices are influenced by demand, availability, route, season and airline pricing.
                </p>
                <p>
                  If your travel dates are flexible, compare several dates to see how the fare changes. Setting up price alerts can help you track fare changes before booking. For popular routes and busy travel periods, booking earlier can also give you access to a greater selection of first class seats.
                </p>
                <p>
                  The most useful approach is to compare actual fares for your route rather than relying on a fixed booking rule.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />

          <ScrollableContent
            heading={
              <h3>
                Can You Get Last-Minute First Class Flights?
              </h3>
            }
            content={
              <div>
                <p>
                  Last-minute first class flights are available, but there&apos;s no guarantee that waiting until close to departure will result in a cheaper ticket.
                </p>
                <p>
                  First class cabins often contain relatively few seats, meaning availability can disappear quickly. On popular routes, they can also become fully booked fast.
                </p>
                <p>
                  If you need to travel at short notice, search current availability across multiple airlines and compare the complete itineraries. You may find a competitive fare, but it is better to treat a last-minute deal as an opportunity rather than something you can reliably expect. Travelers should also inquire at the ticket counter about available first class seats or upgrade options on the day of departure, as airport upgrades can sometimes be easier for frequent flyers.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />

          <ScrollableContent
            heading={
              <h3>
                Is First Class Worth It?
              </h3>
            }
            content={
              <div>
                <p>
                  Whether first class is worth the extra cost depends on the journey and what you want from the flight.
                </p>
                <p>
                  First class can make a particularly noticeable difference on long overnight journeys. A private suite, fully flat bed, premium dining and access to an exclusive lounge can turn the flight into part of the travel experience.
                </p>
                <p>
                  For shorter flights, the difference may be less dramatic.
                </p>
                <p>
                  Before spending more on a first class ticket, compare the first class fare with the business class fare and consider which features matter most to you, as the overall value can vary based on the route, airline and cabin design for travelers.
                </p>
                <p>
                  If sleeping comfortably, having privacy and enjoying premium service are priorities, first class may provide a very different experience from the lower cabins.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />

          <ScrollableContent
            heading={
              <h3>
                Why Search First Class Flights With <a href="/">First-Class.com</a>?
              </h3>
            }
            content={
              <div>
                <p>
                  Finding the right first class ticket is about more than simply finding the lowest price, because the value can vary by route, flight length, airline, and the features you care about most.
                </p>
                <p>
                  <a href="/">First-Class.com</a> brings together premium flight options so travelers can compare available first class fares, airlines and itineraries in one place, check best prices, review first class airfares, and spot class flight deals or broader flight deals before booking a class flight ticket.
                </p>
                <p>
                  Our search platform makes it easier to:
                </p>
                <ul className="list-disc ml-8 mb-2">
                  <li>Search first class flights worldwide</li>
                  <li>Compare available first class tickets</li>
                  <li>Explore different airlines and routes</li>
                  <li>Compare one-way and return flights</li>
                  <li>Find class airfares for different travel dates</li>
                  <li>Review flight schedules and journey times</li>
                  <li>Discover premium travel options for your next trip</li>
                </ul>
                <p>
                  Whether you&apos;re searching for a cheap first class ticket or looking for an exceptional first class experience, start by comparing the options available for your route.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />

          <ScrollableContent
            heading={
              <h3>
                What are first class flights?
              </h3>
            }
            content={
              <div>
                <p>
                  First class flights are premium airline services that generally provide more space, privacy and personalised service than economy and, depending on the airline, business class.
                </p>
                <p>
                  The exact first class experience varies by airline, aircraft and route.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />

          <ScrollableContent
            heading={
              <h3>
                How much are first class tickets?
              </h3>
            }
            content={
              <div>
                <p>
                  The price of first class tickets varies considerably. Factors such as the airline, route, aircraft, travel dates, demand and availability all influence the fare.
                </p>
                <p>
                  International first class tickets can cost several thousand dollars, while shorter domestic first class flights can be considerably less.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />

          <ScrollableContent
            heading={
              <h3>
                Where can I find cheap first class flights?
              </h3>
            }
            content={
              <p>
                You can compare available first class flights and fares through <a href="/">First-Class.com</a>. Being flexible with your travel dates, airports and routing can also give you more opportunities to find a lower fare.
              </p>
            }
            style={styles.scrollableContentSub}
          />

          <ScrollableContent
            heading={
              <h3>
                Which airlines offer first class?
              </h3>
            }
            content={
              <div>
                <p>
                  Airlines offering first class on selected routes include Emirates, Singapore Airlines, Etihad Airways, Lufthansa, British Airways, Air France, Cathay Pacific, ANA and other international carriers.
                </p>
                <p>
                  First class isn&apos;t available on every route, even when an airline operates a first class cabin elsewhere in its network.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />
       <ScrollableContent
            heading={
              <h3>
                What is included in a first class ticket?
              </h3>
            }
            content={
              <div>
                <p>
                  The benefits depend on the airline, aircraft and route. They can include a spacious seat or private suite, premium dining, priority airport services, lounge access, additional baggage and personalised onboard service.
                </p>
                <p>
                  Check the conditions of the specific fare before booking.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />
       <ScrollableContent
            heading={
              <h3>
                Do first class seats turn into beds?
              </h3>
            }
            content={
              <p>
                Many long-haul international first class seats convert into fully flat beds. However, not every first class seat does. Short-haul and domestic first class cabins may use reclining seats instead.
              </p>
            }
            style={styles.scrollableContentSub}
          />
       <ScrollableContent
            heading={
              <h3>
                Do first class passengers get lounge access?
              </h3>
            }
            content={
              <p>
                Many first class tickets include access to an airline&apos;s first class or premium lounge. The exact lounge and facilities depend on the airline and airport.
              </p>
            }
            style={styles.scrollableContentSub}
          />
       <ScrollableContent
            heading={
              <h3>
                Is first class better than business class?
              </h3>
            }
            content={
              <div>
                <p>
                  First class generally offers a more exclusive and private experience, but the difference varies by airline and aircraft. Some modern business class suites offer a very high level of privacy and comfort.
                </p>
                <p>
                  Compare the specific aircraft and seat rather than relying only on the cabin name.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />
       <ScrollableContent
            heading={
              <h3>
                What is the difference between first class and economy?
              </h3>
            }
            content={
              <p>
                First class generally provides substantially more space, privacy and service than economy. Depending on the airline, it may include a larger seat or private suite, a flat bed, premium dining, lounge access and priority airport services.
              </p>
            }
            style={styles.scrollableContentSub}
          />
       <ScrollableContent
            heading={
              <h3>
                Can I book a one-way first class ticket?
              </h3>
            }
            content={
              <p>
                Yes. First class is available as a one-way option on routes where the airline operates the cabin.
              </p>
            }
            style={styles.scrollableContentSub}
          />
       <ScrollableContent
            heading={
              <h3>
                Can I book a return first class ticket?
              </h3>
            }
            content={
              <p>
                Yes. Return or round-trip first class itineraries are available on many routes and can be compared alongside one-way fares.
              </p>
            }
            style={styles.scrollableContentSub}
          />
       <ScrollableContent
            heading={
              <h3>
                Can I book first class at the last minute?
              </h3>
            }
            content={
              <p>
                Yes, first class tickets can be purchased close to departure when seats remain available. However, last-minute fares aren&apos;t guaranteed to be cheaper.
              </p>
            }
            style={styles.scrollableContentSub}
          />
       <ScrollableContent
            heading={
              <h3>
                How can I get cheaper first class airfare?
              </h3>
            }
            content={
              <p>
                Try comparing multiple airlines and travel dates, checking nearby airports and considering connecting flights. Searching early and comparing different fare options can also give you more choice.
              </p>
            }
            style={styles.scrollableContentSub}
          />
       <ScrollableContent
            heading={
              <h3>
                Are first class tickets refundable?
              </h3>
            }
            content={
              <div>
                <p>
                  Refund and cancellation conditions vary by airline and fare type. Some first class fares are refundable, while discounted fares may have restrictions or cancellation fees.
                </p>
                <p>
                  Always check the fare rules before purchasing.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading={
              <h3>
                Do first class tickets include checked baggage?
              </h3>
            }
            content={
              <p>
                First class fares often include a more generous baggage allowance than economy. The exact allowance varies by airline, route and fare.
              </p>
            }
            style={styles.scrollableContentSub}
          />
          <ScrollableContent
            heading={
              <h3>
                Is first class available on every airline?
              </h3>
            }
            content={
              <p>
                No. Many airlines don&apos;t operate a first class cabin, and airlines that do offer first class may operate it only on selected aircraft and routes.
              </p>
            }
            style={styles.scrollableContentSub}
          />       <ScrollableContent
            heading={
              <h3>
                What should I look for when buying a first class ticket?
              </h3>
            }
            content={
              <div>
                <p>
                  Look at the total price, airline, aircraft, seat or suite, flight duration, connections, lounge access, baggage allowance and fare conditions.
                </p>
                <p>
                  The best first class ticket for your trip isn&apos;t necessarily the one with the lowest advertised price.
                </p>
              </div>
            }
            style={styles.scrollableContentSub}
          />
        </div>
      )}
    </div>
  );
  return (
    <>
      <PopularDirections
        popularDirections={popularDirections}
        recommendation={recommendation}
        popularRoutes={popularRoutes}
        directionsPage={directionsPage}
        routesPage={routesPage}
        totalRoutesPages={totalRoutesPages}
        totalDirectionsPages={totalDirectionsPages}
        cabinClass={'first-class'}
        topImage={'/images/first-class.jpg'}
        authCompleted={authCompleted}
        seoHTML={seoHtml}
      />
    </>
  );
}

export default withLayout(Flights, false);
